import axios from './axiosConfig'
import { ICallFlow } from '@dataTypes/clinic.type'
import { getEnv } from '@utils/env'
import { toApiError } from './errors/api-error'
import { serializeCallFlowTeams } from '@utils/callFlowTeam.util'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

const headers = {
  'Content-Type': 'application/json',
}

type ApiResponse<T> = { statusCode: number; message: string; data: T }

export const getCallFlows = async (
  clinicId: string,
): Promise<ApiResponse<{ call_flows: ICallFlow[] }>> => {
  try {
    const res = await axios.get(
      `${BUSINESS_LAYER_API}/api/v1/clinic/call-flow`,
      {
        headers,
        params: { clinic_id: clinicId },
      },
    )
    return res.data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed')
  }
}

export const getCallFlowById = async (
  id: string,
): Promise<ApiResponse<{ call_flow: ICallFlow }>> => {
  try {
    const res = await axios.get(
      `${BUSINESS_LAYER_API}/api/v1/clinic/call-flow/${id}`,
      { headers },
    )
    return res.data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed')
  }
}

export const createCallFlowRequest = async (body: {
  clinic_id: string
  name: string
  flow_type?: 'call' | 'sms'
  status?: string
  definition?: Record<string, unknown>
  clinic_number_ids?: string[]
}): Promise<ApiResponse<{ call_flow: ICallFlow }>> => {
  try {
    const res = await axios.post(
      `${BUSINESS_LAYER_API}/api/v1/clinic/call-flow`,
      {
        ...body,
        ...(body.definition
          ? { definition: serializeCallFlowTeams(body.definition) }
          : {}),
      },
      { headers },
    )
    return res.data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed')
  }
}

export const updateCallFlowRequest = async (
  id: string,
  body: {
    name?: string
    status?: string
    definition?: Record<string, unknown>
    clinic_number_ids?: string[]
  },
): Promise<ApiResponse<{ call_flow: ICallFlow }>> => {
  try {
    const res = await axios.put(
      `${BUSINESS_LAYER_API}/api/v1/clinic/call-flow/${id}`,
      {
        ...body,
        ...(body.definition
          ? { definition: serializeCallFlowTeams(body.definition) }
          : {}),
      },
      { headers },
    )
    return res.data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed')
  }
}

export const deleteCallFlowRequest = async (
  id: string,
): Promise<ApiResponse<Record<string, never>>> => {
  try {
    const res = await axios.delete(
      `${BUSINESS_LAYER_API}/api/v1/clinic/call-flow/${id}`,
      { headers },
    )
    return res.data
  } catch (e: unknown) {
    throw toApiError(e, 'Failed')
  }
}
